import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const InventarioOtrosAcopiosApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAcopiosConsultables = async () => {
        try {
            setCargando(true);
            const response = await api.get(
                "inventario_otros_acopios/acopios_consultables",
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getUltimoInventario = async (acopioId) => {
        try {
            setCargando(true);
            const response = await api.get(
                "inventario_otros_acopios/ultimo_inventario",
                { acopio_id: acopioId },
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // El sobrante del almacén sale de los mismos endpoints que consume la
    // gestión propia; los dos son de lectura
    const getDetalleAlmacen = async (inventarioAlmacenId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `almacen_inventario/detalle_almacen/${inventarioAlmacenId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getAnalisisSobrante = async (inventarioAlmacenId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `analisis_drc_inventario/analisis_drc_almacen/${inventarioAlmacenId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getAcopiosConsultables,
        getUltimoInventario,
        getDetalleAlmacen,
        getAnalisisSobrante,

        cargando,
    };
};
